import { useEffect, useState } from "react";

import { projectInfosWithDeps } from "../../../../../resources/projects";

export const useProjectDeps = (projectName?: string) => {
  const [loading, setLoading] = useState<boolean>(true);

  const { data: projectInfo, refetch } = projectInfosWithDeps.use({
    input: [projectName],
    waitInput: true,
    immediate: false,
  });

  useEffect(() => {
    refetch().then(() => setLoading(false));
  }, [refetch]);

  return {
    layers: projectInfo?.deps.layers,
    tables: projectInfo?.deps.tables,
    loading,
  };
};
